import React from "react";

// Generic PULB DRMS product logo (monogram badge).
export default function PunjabEmblem({ size = 44, className = "" }) {
  return (
    <svg
      viewBox="0 0 100 100"
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="PULB DRMS logo"
    >
      <rect x="4" y="4" width="92" height="92" rx="22" fill="#0F2942" />
      <rect x="22" y="58" width="10" height="18" rx="2" fill="#E8702A" />
      <rect x="38" y="46" width="10" height="30" rx="2" fill="#FFFFFF" />
      <rect x="54" y="36" width="10" height="40" rx="2" fill="#FFFFFF" />
      <rect x="70" y="24" width="10" height="52" rx="2" fill="#0D7650" />
      <path d="M22 44 L46 30 L60 36 L80 16" stroke="#E8702A" strokeWidth="4" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
